import * as S from './styled'

import { useState } from 'react'
import api from '@/core/services/api'
import useFormData from '@/core/hooks/useFormData'
import useTableData from '@/core/hooks/useTableData'

import Header from '@/components/common/Header'
import VendorList from '@/components/VendorList'
import Footer from '@/components/Footer'
import GoldBanner from '@/components/gold/GoldBanner'
import GoldNews from '@/components/gold/GoldNews'
import GoldRecentView from '@/components/gold/GoldRecentView'
import GoldNoticePopup from '@/components/gold/GoldNoticePopup'

/**
 * 메인 페이지
 */
export default function Main() {
  const [scrollNotice, setScrollNotice] = useState(null)

  const handleGetData = () => {
    api.get(`/site/banner`)
      .then((res) => {
        getData.setData(res.data.content)
      })
      .catch((err) => {
        console.error(err)
      })
  }

  const getData = useTableData(true)
  useFormData(
    {},
    handleGetData,
    getData,
    true
  )

  const getScrollData = useTableData(true)
  useFormData(
    {},
    () => {
      api.get(`/site/scroll`)
        .then((res) => {
          const { contents, is_inspection_visible } = res.data.content
          if (is_inspection_visible && contents) {
            setScrollNotice(contents)
          }
        })
        .catch((err) => {
          console.error(err)
        })
    },
    getScrollData,
    true
  )

  return (
    <>
      {/* ver2(gold) 순서: 헤더(고정) → 배너 → 공지 띠 → 게임사 타일 → 하단 → 「歴史」 서랍 */}
      <S.Page>
        <Header />
        <GoldBanner banners={getData.data} loading={getData.data === null} />
        <S.Body>
          <GoldNews />
          <S.HomeGrid>
            <VendorList />
          </S.HomeGrid>
        </S.Body>
        <Footer />
      </S.Page>
      {scrollNotice && (
        <S.ScrollNotice>
          <S.ScrollNoticeTrack>{scrollNotice}</S.ScrollNoticeTrack>
        </S.ScrollNotice>
      )}
      <GoldRecentView />
      <GoldNoticePopup />
    </>
  )
}
